import { createApp } from "vue";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
// @ts-ignore
import veProgress from "vue-ellipse-progress";
import App from "./App.vue";
import router from "./router";
import FloatingVue from 'floating-vue';
import { sendSentryEvent } from "@/helpers/sentryHelpers";

//@ts-ignore
import { outsideClick, documentKeyup } from "@altium/identity-ui-library";
import CountryFlag from 'vue-country-flag-next';

import "devextreme/dist/css/dx.light.css";
import "vue-toast-notification/dist/theme-default.css";
import "../node_modules/@altium/identity-ui-library/dist/style.css";
import "./assets/css/main.min.css";
import "./assets/css/tailwind-like.css";
import "./assets/css/custom.scss";
import 'floating-vue/dist/style.css';

const app = createApp(App);

export const pinia = createPinia();

app.use(pinia);
const dsn = import.meta.env["VITE_SENTRY_DSN"] as string | undefined;

Sentry.init({
  app,
  dsn,
  environment: import.meta.env.MODE,
  release: `${import.meta.env["VITE_APP_NAME"]}@${import.meta.env["VITE_APP_VERSION"]}`,
  attachProps: true,
  attachStacktrace: true,
  trackComponents: false,
  integrations: [
    Sentry.browserTracingIntegration({ router })
  ],
  maxBreadcrumbs: 10,
  sendClientReports: true,
  autoSessionTracking: true,
  sampleRate: 1.0,
  tracesSampleRate: 0.1,
});

app.component('country-flag', CountryFlag);
app.directive("outside-click", outsideClick);
app.directive("document-keyup", documentKeyup);

app.use(router);
app.use(FloatingVue, {
  themes: {
    'dashboard': {
      $extend: 'tooltip',
      triggers: ['hover'],
      autoHide: true,
      html: true,
      distance: 12
    },
  }
});

app.use(veProgress);

app.config.errorHandler = (error: any) => {
  if (error.message.includes("Failed to fetch dynamically imported module")
    || error.message.includes("Importing a module script failed")) {
    // Ignore this type of error since it is handled in app router
    // This type of error occurs after front-end is deployed when assets' hashes are changed
    return;
  }

  sendSentryEvent(error, 'fatal');
};

app.mount("#app");
